export default "__VITE_ASSET__Bs88Z9AN__"